export default __webpack_public_path__ + "static/media/purple-candy.5d6b3ddf.png";